declare global {
    interface Window {
        dataLayer: Record<string, unknown>[]
    }
}

const analytics = {
    logEvent(eventName: string, params?: Record<string, unknown>): void {
        const normalizedEventName = eventName.toLowerCase()
        console.log('[Analytics] logEvent', {
            eventName: normalizedEventName,
            params: params ?? {},
        })

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            event: normalizedEventName,
            ...params,
        })
    },

    setUserProperties(properties: Record<string, unknown>): void {
        console.log('[Analytics] setUserProperties', {
            eventName: 'set_user_properties',
            params: properties,
        })

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            event: 'set_user_properties',
            ...properties,
        })
    },
}

export default analytics
